import { Suspense, lazy } from 'react';
import EmptyCard from '../../components/EmptyCard/EmptyCard';
import { Card, Flex, Spin } from 'antd';
import Legend from './Legend';
import PropTypes from 'prop-types';

// Lazy load the Plot component with basic plotly
const Plot = lazy(() => import('../../components/Plot/Plot'));

const PlotCard = ({ title, plotData, layout, legendItems }) => {
  return (
    <Card
      size="small"
      title={title}
      variant="borderless"
      className="full-height"
    >
      {plotData.length > 0 ? (
        <Flex vertical gap="large" className="full-height">
          <Legend items={legendItems} />
          <div
            style={{
              width: '100%',
              overflowX: 'auto',
            }}
          >
            <div
              style={{
                width: `${plotData[0]?.x?.length * 70}px`,
                minWidth: '600px',
              }}
            >
              <Suspense
                fallback={
                  <Flex
                    justify="center"
                    align="center"
                    style={{ height: '350px' }}
                  >
                    <Spin size="large" />
                  </Flex>
                }
              >
                <Plot
                  data={plotData}
                  layout={layout}
                  config={{
                    responsive: true,
                    displayModeBar: false,
                  }}
                  style={{ width: '100%', height: '350px' }}
                />
              </Suspense>
            </div>
          </div>
        </Flex>
      ) : (
        <EmptyCard customStyle={{ height: 425 }} />
      )}
    </Card>
  );
};

PlotCard.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  plotData: PropTypes.arrayOf(PropTypes.object),
  layout: PropTypes.object,
  legendItems: PropTypes.arrayOf(PropTypes.object),
};

export default PlotCard;
